import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useMasterApi() {
  const callApi = useApiCall();

  const getLicensesList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MASTER.GET_LICENSES, data, onSuccess, onError);
  }; 

  const getLanguagesList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MASTER.GET_LANGUAGES, data, onSuccess, onError);
  }; 
  const getCompanyList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MASTER.GET_COMPANY, data, onSuccess, onError);
  }; 
  const getMasterModuleList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MASTER.GET_MASTER_MODULE, data, onSuccess, onError);
  }; 


  return {
    getLicensesList, 
    getLanguagesList,
    getCompanyList,
    getMasterModuleList
  };
}
